import styled from 'styled-components';
import { fonts, colors } from 'stylesheets';

import DatePicker from 'react-datepicker';

export const Content = styled.div`
  display: block;
`;

export const ContentText = styled.div`
  text-align: center;
  font-family: ${fonts.primary};
  margin-top: ${({ marginTop }) => marginTop || 0}px;
  text-align: ${({ textAlign }) => textAlign || 'center'};
  margin-left: ${({ marginLeft }) => marginLeft || 0}px;
`;

export const InputContainer = styled.div`
  text-align: center;
  width: 100%;
  height: 315px;
`;

export const ContentInput = styled(DatePicker)`
  width: 520px;
  margin: 0 20px;
  height: 42px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 3px;
  margin-top: 10px;
  padding: 10px;
  color: ${colors.grey};
  cursor: pointer;
`;

export const ImageInput = styled.img`
  width: 23px;
  height: 23px;
  position: relative;
  bottom: 36px;
  left: 245px;
  cursor: pointer;
`;

export const BackButton = styled.span`
  margin: 0 20px;
  color: ${colors.primary};
  font: 13px ${fonts.secondary};
  cursor: pointer;
  &:hover {
    font-weight: 800;
  }
`;
